import TopRevisitTime from 'modules/Dashboard/TopRevisitTime';
import { Statistics } from 'shared/model/statistic.model';
import Metric from 'shared/routes/components/Metric/Metric';

type Props = {
  stats?: Statistics;
};

const TopRevisitTimes = ({ stats }: Props) => {
  return (
    <Metric label="Top 5 Revisit Time">
      {stats?.topRevisitTimes.map(item => {
        return <TopRevisitTime key={item.name} item={item} />;
      })}
    </Metric>
  );
};

export default TopRevisitTimes;
